import * as React from "react";
import { Link } from "react-router-dom";
// import Logo from './../../assets/images/logo.png';
import $ from "jquery";
import Countdown from "react-countdown";
import { FaClinicMedical, FaHandHoldingMedical } from "react-icons/fa";
import {
  getCookie,
  getStorage,
  getUserDetail,
  setCookie,
  setStorage,
} from "../../utils";
import CONSTANT from "./../../constant";

import { restartLoggedInUserSession } from "../../actions/AuthAction";
import "./../../assets/css/sidebar.css";
import constant from "./../../constant";

export class SessionTimer extends React.PureComponent<any, any> {
  private timerInterval: NodeJS.Timeout | null = null;

  constructor(props: any) {
    super(props);

    const ud = getUserDetail();
    const issuedAt = ud?.issuedAt ?? Date.now();
    const delayMs = 8 * 60 * 60 * 1000; // 8 hours in milliseconds
    // const delayMs = 1 * 60 * 1000; // for testing

    this.state = {
      value: issuedAt + delayMs,
      ud,
      hasAlertShown: false, // track if alert has been shown
    };
  }

  componentDidMount() {
    // Set up an interval to check the remaining time
    this.timerInterval = setInterval(this.checkRemainingTime, 1000);
  }

  componentWillUnmount() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  checkRemainingTime = () => {
    const { value, hasAlertShown } = this.state;
    const now = Date.now();
    const remainingTime = value - now;
    const tenMinutes = 10 * 60 * 1000;

    if (remainingTime <= tenMinutes && !hasAlertShown) {
      // Show alert when less than 10 minutes remain and alert hasn't been shown yet
      alert("Your session will expire in 10 minutes. Please save your work.");
      this.setState({ hasAlertShown: true });

      // Optionally restart the session automatically
      // this.restartSession();
    }
  };

  shouldComponentUpdate(nextProps: any, nextState: any) {
    return false;
  }

  restartSession() {
    let ud = getUserDetail();

    if (ud) {
      restartLoggedInUserSession(ud.code)
        .then((response: any) => {
          if (response.status == constant.static.apiStatus.success) {
            this.setState(
              {
                ...this.state,
                value: Date.now() + 8 * 60 * 60 * 1000, // reset to 8 hours
                hasAlertShown: false, // reset alert flag
              },
              () => {
                setCookie(CONSTANT.cookie.token, response.result.token);
                setCookie(
                  CONSTANT.cookie.userDetail,
                  response.result.userDetail
                );
              }
            );
          }
        })
        .catch((err: any) => {
          alert(err);
        });
    }
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div
            className={
              this.state.b_list !== undefined && this.state.b_list.length !== 0
                ? "col-2 : bg-white"
                : "col-2"
            }
          >
            <Countdown
              date={this.state.value}
              renderer={({ hours, minutes, seconds, completed }) => {
                if (completed) {
                  return <span>Session expired</span>;
                } else {
                  return (
                    <div className="d-flex font-bold justify-content-between align-items-center p-2">
                      <h4 className="d-flex text-nowrap timerarea">
                        {hours.toString().padStart(2, "0")}:
                        {minutes.toString().padStart(2, "0")}:
                        {seconds.toString().padStart(2, "0")}
                      </h4>
                    </div>
                  );
                }
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

class Header extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      userDetail: getCookie(CONSTANT.cookie.userDetail),
      finance: getCookie(CONSTANT.cookie.finance),
      ud: 1860,
      isExpanded: true,
      openMainMenu: "",     // for main menus (E-Filing, APAR)
      openSubMenu: "",      // for submenus (Reporting Manager, etc.)
    };
  }

  toggleMenu = () => {
    this.setState({ isExpanded: !this.state.isExpanded, openMainMenu: "", openSubMenu: "" });
  };

  toggleMainMenu = (value: string) => {
    this.setState((prevState: any) => ({
      openMainMenu: prevState.openMainMenu === value ? "" : value,
      openSubMenu: "" // close submenu when main menu changes
    }));
  };

  toggleSubMenu = (value: string) => {
    this.setState((prevState: any) => ({
      openSubMenu: prevState.openSubMenu === value ? "" : value
    }));
  };

  componentDidMount() {
    const body = document.body,
      html = document.documentElement;
    const height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    $(".left-menu").height("auto");
  }

  render() {
    const ud = getCookie(CONSTANT.cookie.userDetail);
    const permissions = getStorage(CONSTANT.cookie.permissions);
    const { userDetail } = this.state;
    const { isExpanded, openMainMenu, openSubMenu } = this.state;

    return (
      <div className="h-screen left-menu">
        <div
          className={`stickyaside transition-all duration-500 ease-in-out ${
            isExpanded ? "w-64" : "w-15"
          } flex flex-col shadow-xl`}
        >
          {/* Header */}
          <div className="p-2 flex items-center justify-between">
            {isExpanded && (
              <h2 className="text-xl font-bold whitespace-nowrap text-white pl-4">
                File Menu
              </h2>
            )}
            <button
              onClick={this.toggleMenu}
              className={`p-2 rounded-lg hover:bg-blue-900 transition-colors ${
                isExpanded ? "mx-right" : "mx-auto"
              } text-white`}
            >
              {isExpanded ? (
                <i className="fa fa-times text-xl"></i>
              ) : (
                <i className="fa fa-bars text-xl"></i>
              )}
            </button>
          </div>
          <div className="navbar navbar-expand-lg p-0">
            <div className="w-100">
              <ul>
                <li>
                  <Link to={CONSTANT.component.userFileList.url}>
                    <i className="fa fa-file-text-o"></i>
                    {isExpanded && "DashBoard"}
                  </Link>
                </li>
              </ul>

              {ud.designationCode === 370 ? (
                <ul>
                  <li>
                    <Link to={CONSTANT.component.dakManagementCreate.url}>
                      <i className="fa fa-file-archive-o" />
                      {isExpanded && "DAK Management"}
                    </Link>
                  </li>
                </ul>
              ) : (
                <ul>
                  {permissions?.indexOf(
                    CONSTANT.static.permissions.hodFileReport
                  ) > -1 && (
                    <>
                      {/* <li>
                        <Link to={CONSTANT.component.userFileReport.url}>
                          <i className="fa fa-bar-chart" />
                          {isExpanded && "HOD Report"}
                        </Link>
                      </li> */}
                    </>
                  )}
                  {
                    <>
                      {/* E-Filing Menu */}
                      {/* <li className="text-white">
                        <button
                          className="flex justify-content-between w-100"
                          onClick={() => {
                            if (isExpanded) {
                              this.toggleMainMenu("E-Filing");
                            }
                          }}
                        >
                          <i className="fa fa-file-text-o text-white" />
                          {isExpanded && "E-Filing"}

                          {isExpanded &&
                            (openMainMenu == "E-Filing" ? (
                              <i className="fa fa-chevron-down transition-transform duration-300 ml-1 text-white ml-auto"></i>
                            ) : (
                              <i className="fa fa-chevron-right transition-transform duration-300 ml-1 text-white ml-auto"></i>
                            ))}
                        </button>
                        <div
                          className={`overflow-hidden transition-all duration-500 ease-in-out ${
                            openMainMenu == "E-Filing"
                              ? "max-h-96 opacity-100"
                              : "max-h-0 opacity-0"
                          }`}
                        >
                          <ul
                            className="mt-2 space-y-1 border-l-2 border-blue-500 pt-1"
                          >
                            <li className="px-2 py-1 border-0 bg-none">
                              <Link
                                className="flex items-center transition-all duration-200 group"
                                to={constant.component.myFiles.url}
                              >
                                <i className={``} />
                                <span className="font-normal whitespace-nowrap">
                                  My Files
                                </span>
                              </Link>
                            </li>
                            <li className="px-2 py-1 border-0">
                              <Link
                                to={constant.component.inbox.url}
                                className="flex items-center transition-all duration-200 group"
                              >
                                <i className={``} />
                                <span className="font-normal whitespace-nowrap">
                                  Inbox
                                </span>
                              </Link>
                            </li>
                            <li className="px-2 py-1 border-0">
                              <Link
                                to={constant.component.outbox.url}
                                className="flex items-center transition-all duration-200 group"
                              >
                                <i className={``} />
                                <span className="font-normal whitespace-nowrap">
                                  Outbox
                                </span>
                              </Link>
                            </li>
                            { ud?.isHOD && (
                              <li className="px-2 py-1 border-0 bg-none">
                                <Link
                                  className="flex items-center transition-all duration-200 group"
                                  to={CONSTANT.component.pendingHodFiles.url}
                                >
                                  <i className={``} />
                                  {isExpanded && "Pending Approval"}
                                </Link>
                              </li>
                            )}
                          </ul>
                        </div>
                      </li> */}

                      {/* APAR Menu */}
                      <li className="text-white">
                        <button
                          className="flex justify-content-between w-100"
                          onClick={() => {
                            if (isExpanded) {
                              this.toggleMainMenu("APAR");
                            }
                          }}
                        >
                          <i className="fa fa-file-pdf-o text-white" />
                          {isExpanded && "APAR"}

                          {isExpanded &&
                            (openMainMenu == "APAR" ? (
                              <i className="fa fa-chevron-down transition-transform duration-300 ml-1 text-white ml-auto"></i>
                            ) : (
                              <i className="fa fa-chevron-right transition-transform duration-300 ml-1 text-white ml-auto"></i>
                            ))}
                        </button>
                        
                        {/* Main APAR Submenu */}
                        <div
                          className={`overflow-hidden transition-all duration-500 ease-in-out ${
                            openMainMenu == "APAR"
                              ? "max-h-96 opacity-100"
                              : "max-h-0 opacity-0"
                          }`}
                        >
                          <ul className="mt-2 space-y-2 border-l-2 border-blue-500 pt-1">
                            
                            {/* HR ACCESS OPTIONS - Direct Links */}
                            {permissions?.indexOf(CONSTANT.static.permissions.aparHRAccess) > -1 && (
                              <>
                                <li className="px-2 py-1 border-0 bg-none">
                                  <Link
                                    className="flex items-center transition-all duration-200 group text-white hover:text-blue-300"
                                    to={constant.component.manageEmployee.url}
                                  >
                                    {/* <i className="fa fa-users mr-2" /> */}
                                    <span className="font-normal whitespace-nowrap">
                                      Manage Employee
                                    </span>
                                  </Link>
                                </li>
                                <li className="px-2 py-1 border-0 bg-none">
                                  <Link
                                    className="flex items-center transition-all duration-200 group text-white hover:text-blue-300"
                                    to={constant.component.startAppraisalCycle.url}
                                  >
                                    {/* <i className="fa fa-calendar-plus-o mr-2" /> */}
                                    <span className="font-normal whitespace-nowrap">
                                      Start Appraisal Cycle
                                    </span>
                                  </Link>
                                </li>
                                <li className="px-2 py-1 border-0 bg-none">
                                  <Link
                                    className="flex items-center transition-all duration-200 group text-white hover:text-blue-300"
                                    to={constant.component.aparBulkUploadAuthority.url}
                                  >
                                    <span className="font-normal whitespace-nowrap">
                                      Bulk Upload
                                    </span>
                                  </Link>
                                </li>
                              </>
                            )}

                            {/* View Reports - Direct Link */}
                             {permissions?.indexOf(CONSTANT.static.permissions.aparHRAccess) > -1 && (
                            <li className="px-2 py-1 border-0 bg-none">
                              <Link
                                className="flex items-center transition-all duration-200 group text-white hover:text-blue-300"
                                to={constant.component.viewReports.url}
                              >
                                {/* <i className="fa fa-file-text-o mr-2" /> */}
                                <span className="font-normal whitespace-nowrap">
                                  View Reports
                                </span>
                              </Link>
                            </li>
  )}
                            {/* Download Reports - HR Only */}
                            {permissions?.indexOf(CONSTANT.static.permissions.aparHRAccess) > -1 && (
                            <li className="px-2 py-1 border-0 bg-none">
                              <Link
                                className="flex items-center transition-all duration-200 group text-white hover:text-blue-300"
                                to={constant.component.aparHrDownloadReports.url}
                              >
                                <span className="font-normal whitespace-nowrap">
                                  Download Reports
                                </span>
                              </Link>
                            </li>
  )}

                            {/* Self Appraisal - Direct Link */}
                           
                              <li className="px-2 py-1 border-0 bg-none">
                                <Link
                                  className="flex items-center transition-all duration-200 group text-white hover:text-blue-300"
                                  to={constant.component.selfAppraisal.url}
                                >
                                  {/* <i className="fa fa-pencil-square-o mr-2" /> */}
                                  <span className="font-normal whitespace-nowrap">
                                    Self Appraisal
                                  </span>
                                </Link>
                              </li>
                          

                            {/* Separator Line */}
                            {/* <li className="border-t border-blue-500 my-1"></li> */}

                            {/* REPORTING MANAGER */}
                            <li className="px-2 py-1 border-0 bg-none">
                              <Link
                                to={constant.component.reportingManagerReport.url}
                                className="flex items-center transition-all duration-200 text-white hover:text-blue-300"
                              >
                                <span>Reporting Authority</span>
                              </Link>
                            </li>

                            {/* REVIEWING MANAGER */}
                            <li className="px-2 py-1 border-0 bg-none">
                              <Link
                                to={constant.component.reviewingManagerReport.url}
                                className="flex items-center transition-all duration-200 text-white hover:text-blue-300"
                              >
                                <span>Reviewing Authority</span>
                              </Link>
                            </li>

                            {/* ACCEPTING MANAGER */}
                            <li className="px-2 py-1 border-0 bg-none">
                              <Link
                                to={constant.component.acceptingManagerReport.url}
                                className="flex items-center transition-all duration-200 text-white hover:text-blue-300"
                              >
                                <span>Acceptance Authority</span>
                              </Link>
                            </li>

                            
                          </ul>
                        </div>
                      </li>

                      {/* Circular Menu */}
                      {/* <li>
                        <Link to={CONSTANT.component.circularList.url}>
                          <i className="fa fa-circle-o-notch" aria-hidden="true"></i>
                          {isExpanded && "Circular"}
                        </Link>
                      </li> */}

                      {/* Delete Files */}
                      {/* {permissions?.indexOf(CONSTANT.static.permissions.deleteFileAccess) > -1 && (
                        <li>
                          <Link to={CONSTANT.component.dltFIles.url}>
                            <i className="fa fa-trash" aria-hidden="true"></i>
                            {isExpanded && "Delete Files"}
                          </Link>
                        </li>
                      )} */}

                      {/* Parked Files */}
                      {/* <li>
                        <Link to={CONSTANT.component.userParkedFileList.url}>
                          <i className="fa fa-file-archive-o" />
                          {isExpanded && "Parked Files"}
                        </Link>
                      </li> */}

                      {/* Approved Files */}
                      {/* <li>
                        <Link to={CONSTANT.component.approvedFileReport.url}>
                          <i className="fa fa fa-check-circle" />
                          {isExpanded && "Approved Files"}
                        </Link>
                      </li> */}

                      {/* DAK Management */}
                      {/* {permissions?.indexOf(CONSTANT.static.permissions.dakAccess) > -1 && (
                        <li>
                          <Link to={CONSTANT.component.dakManagementCreate.url}>
                            <i className="fa fa-file" />
                            {isExpanded && "DAK Management"}
                          </Link>
                        </li>
                      )} */}
                    </>
                  }

                  {/* Knowledge Management */}
                  {/* {permissions?.indexOf(CONSTANT.static.permissions.kmMenuAccess) > -1 && (
                    <li>
                      <Link to={CONSTANT.component.knowledgeManagementSystem.url}>
                        <i className="fa fa-arrow-down" aria-hidden="true" />
                        {isExpanded && "Knowledge Management"}
                      </Link>
                    </li>
                  )} */}

                  {/* E-Tour */}
                  {/* <li>
                    <Link to={CONSTANT.component.userETourList.url}>
                      <i className="fa fa-plane" />
                      {isExpanded && "E-Tour"}
                    </Link>
                  </li> */}

                  {/* Medical Claim */}
                  {/* <li>
                    <Link to={CONSTANT.component.listMedicalClaim.url}>
                      <i className="fa fa-heartbeat" />
                      {isExpanded && "Medical Claim"}
                    </Link>
                  </li> */}

                  {/* Property Return */}
                  {/* <li>
                    <Link to={CONSTANT.component.EmpPropertyReturn.url}>
                      <i className="fa fa-file"/>
                      Property Return
                    </Link>
                  </li> */}

                  {/* Medical Desk */}
                  {Array.isArray(getStorage(CONSTANT.cookie.hrDealingOfficerList)) &&
                  getStorage(CONSTANT.cookie.hrDealingOfficerList).length > 0 &&
                  this.state.userDetail.code ===
                    getStorage(CONSTANT.cookie.hrDealingOfficerList)[0].code ? (
                    <li>
                      <Link to={CONSTANT.component.medicalDesk.url}>
                        <i className="" style={{ float: "left" }}>
                          <FaHandHoldingMedical />
                        </i>
                        {isExpanded && "Medical Desk"}
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}

                  {/* Medical Desk Admin */}
                  {(getStorage(CONSTANT.cookie.hrexecutive)?.[0]?.code == this.state.userDetail.code ||
                  getStorage(CONSTANT.cookie.finance)?.some(
                    (ele: any) => ele.code == this.state.userDetail.code
                  )) ? (
                    <li>
                      <Link to={CONSTANT.component.medicalDesk.url}>
                        <i className="" style={{ float: "left" }}>
                          <FaClinicMedical />{" "}
                        </i>
                        {isExpanded && "Medical Desk Admin"}
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}

                  {/* Probation Completion Confirmation */}
                  {permissions?.indexOf(CONSTANT.static.permissions.probationCompletionConfirmation) > -1 && (
                    <li>
                      <Link to={CONSTANT.component.probationCompletionConfirmation.url}>
                        <i className="fa fa-address-card" />
                        {isExpanded && "Probation Completion Confirmation"}
                      </Link>
                    </li>
                  )}

                  {/* Probation Completion Initiation */}
                  {permissions?.indexOf(CONSTANT.static.permissions.probationCompletionInitiation) > -1 && (
                    <li>
                      <Link to={CONSTANT.component.probationCompletionInitiation.url}>
                        <i className="fa fa-address-card" />
                        {isExpanded && "Probation Completion Initiation"}
                      </Link>
                    </li>
                  )}
                </ul>
              )}

              {/* Admin Section */}
              <ul>
                {permissions?.indexOf(CONSTANT.static.permissions.userAdminAccess) > -1 && (
                  <li>
                    <Link to={CONSTANT.component.adminDashboard.url}>
                      <i className="fa fa-cog" />
                      {isExpanded && "Admin section"}
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;